





















import Vue from 'vue';
import Component from 'vue-class-component';

const AttributePropertiesBase = Vue.extend({
  props: {
    showSubtitle: Boolean,
    imageUrl: String,
  },
});

@Component
export default class TitleBanner extends AttributePropertiesBase {}
